// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ArrowLeft = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ArrowLeft = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var ArrowLeft = _exports.ArrowLeft = function ArrowLeft(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.9189 9.99762C16.9189 10.2914 16.6805 10.5299 16.3867 10.5299H4.89802L8.95726 14.589C9.16519 14.7969 9.16519 15.134 8.95726 15.3419C8.85365 15.4456 8.71737 15.498 8.58112 15.498C8.44486 15.498 8.30859 15.4463 8.20498 15.3419L3.23735 10.3744C3.18838 10.3255 3.14945 10.2667 3.12248 10.2014C3.06855 10.0715 3.06855 9.92461 3.12248 9.79474C3.14945 9.72946 3.18838 9.67046 3.23735 9.62149L8.20498 4.65399C8.41291 4.44607 8.75002 4.44607 8.95795 4.65399C9.16588 4.86192 9.16588 5.19902 8.95795 5.40695L4.89871 9.46608H16.3867C16.6805 9.46537 16.9189 9.70383 16.9189 9.99762Z",
      fill: "currentColor"
    }));
  };
});
